import { StyleProps } from "@shared/primitive-components"
import { fleetSafetyThreshold as threshold } from "../const"

export const getTextColor = (value: number | null, props: StyleProps) => {
  if (value === null) return props.theme.palette.coal.dark
  if (value >= threshold.low) return props.theme.palette.white
  if (value >= threshold.medium) return props.theme.palette.coal.dark
  if (value >= threshold.high) return props.theme.palette.coal.dark
  if (value >= threshold.severe) return props.theme.palette.white
  return props.theme.palette.coal.dark
}

export const getBackgroundColor = (value: number | null, props: StyleProps) => {
  if (value === null) return props.theme.palette.grey.dark
  if (value >= threshold.low) return props.theme.palette.full.green
  if (value >= threshold.medium) return props.theme.palette.full.amber
  if (value >= threshold.high) return props.theme.palette.full.orange
  if (value >= threshold.severe) return props.theme.palette.full.red
  return props.theme.palette.grey.dark
}

export const getSeverityLabelPadding = (value: number | null, props: StyleProps) => {
  if (value === null) return props.theme.spacing(2, 3)
  if (value >= threshold.low) return props.theme.spacing(2, 3)
  if (value >= threshold.medium) return `0.5rem 0.45rem`
  if (value >= threshold.high) return props.theme.spacing(2, 3)
  if (value >= threshold.severe) return `0.5rem 0.45rem`
  return props.theme.spacing(2, 3)
}
